<template>
  <v-container fluid tag="section">
    <div class="white rounded-lg my-2 pa-4">
      <v-row>
        <v-col cols="12" md='2' class="pr-2 pl-3 px-1">
          <base-marerial-user-select outlined dense label='用户选择'  @on-change="statis" hide-details v-model="params.userIds" mid :menu='$constants.SysMenu.CONTRACT_M_ID'></base-marerial-user-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pl-3 px-1">
          <v-select
            :items="yearItems"
            label="年度选择"
            v-model="params.year"
            hide-details='auto'
            item-text="label"
            outlined dense
            clearable
            @change="statis"
          ></v-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pl-3 px-1">
          <v-btn depressed dark :loading='loading' color="primary" @click="statis" class="mx-1 px-2">
            <v-icon size="20" dark>mdi-magnify</v-icon>查询
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="12">
      <v-card :loading='loading' class="elevation-0 rounded-lg">
        <v-card-title>
          客户复签统计
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-simple-table fixed-header class="elevation-0">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">年份</th>
                      <th class="text-center">新增</th>
                      <th class="text-center">流失</th>
                      <th class="text-center">净新增</th>
                      <th class="text-center">复签</th>
                      <th class="text-center">复签率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in result.repeatSigns" :key="idx">
                      <td class="text-center">{{item.year}}</td>
                      <td class="text-center"><span class="cyan--text size-20 font-family-Impact">+{{ item.addNumber }}</span></td>
                      <td class="text-center"><span class="red--text size-20 font-family-Impact">-{{ item.reduceNumber }}</span></td>
                      <td class="text-center"><span class="green--text size-20 font-family-Impact">+{{ item.jaddNumber < 0 ? 0 : item.jaddNumber }}</span></td>
                      <td class="text-center"><span class="teal--text size-20 font-family-Impact">{{ item.repeatNumber }}</span></td>
                      <td class="text-center"><span class="primary--text size-20 font-family-Impact">{{ item.repeatRate }}%</span></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card :loading='loading' class="elevation-0 rounded-lg">
          <v-card-title>
            项目类型统计
          </v-card-title>
          <v-card-text  class="pa-0">
            <v-data-table
              :headers="productHeaders"
              :items="result.productTypes"
              :items-per-page='5'
              :search="productSearch"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="productSearch"
                  hide-details
                  label="输入关键字搜索"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template
                v-for="(head, hidx) in productHeaders"
                v-slot:[`item.${head.value}`]='{ header, value, item }'
                >

                <div :key="hidx" v-if="header.hasOwnProperty('formatter')">
                  {{header.formatter(value, item)}}
                </div>
                <div :key="hidx" v-else>
                  {{value}}
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
      <v-card :loading='loading' class="elevation-0 rounded-lg">
        <v-card-title>
          合同状态统计
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md='7'>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">年度</th>
                      <th class="text-center">总金额</th>
                      <th class="text-center">通过</th>
                      <th class="text-center">未通过</th>
                      <th class="text-center">进行中</th>
                      <th class="text-center">完成</th>
                      <th class="text-center">中止</th>
                      <th class="text-center">通过率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in result.contractStates" :key="idx">
                      <td class="text-center" v-if="item.year !== -1">
                        {{item.year}}
                      </td>
                      <td class="text-center" v-else>
                        合计
                      </td>
                      <td class="text-center">{{ item.signNumber }}</td>
                      <td class="text-center">{{ item.passNumber }}</td>
                      <td class="text-center">{{ item.failNumber }}</td>
                      <td class="text-center">{{ item.doingNumber }}</td>
                      <td class="text-center">{{ item.doneNumber }}</td>
                      <td class="text-center">{{ item.stopNumber }}</td>
                      <td class="text-center">{{ item.passRate }}%</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" md='5'>
              <v-card class="mx-auto" style="height:100%;width:100%" :loading='loading'>
                <v-sheet class="v-sheet--offset mx-auto" height='calc(100% - 65px)' color="primary" >
                  <v-sparkline
                    :labels="stateLabels"
                    :value="stateValue"
                    color="white"
                    line-width="2"
                    padding="15"
                    smooth
                    style="height:100%;width:100%"
                  ></v-sparkline>
                </v-sheet>
                <v-card-text class="pt-0">
                  <v-radio-group row v-model="stateRadio" @change="changeState">
                    <v-radio v-for="(item, idx) in stateItems" :key="idx" :label="item.name"  :value="item.value"></v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'
  import { year } from '@/api/statis/year.js'

  export default {
    name: 'StatisYear',
    filters: {
      filterCollectMoney(item) {
        return (item["passSignPrice"] - item['returnMoney']).toFixed(2)
      }
    },
    data() {
      return {
        params: {
          year: '',
          userIds: []
        },
        loading: false,
        result: {},
        yearItems: selectData2(),
        stateItems: [
          { name: '总金额', value: 'signNumber' },
          { name: '通过', value: 'passNumber' },
          { name: '未通过', value: 'failNumber' },
          { name: '通过率', value: 'passRate' }
        ],
        productSearch: '',
        stateRadio: 'signNumber',
        stateLabels: [],
        stateValue: [],
        productHeaders: [
          {
            text: '项目名称',
            align: 'left',
            width: 250,
            value: 'name',
            sortable: false
          },
          {
            text: '总签单数',
            align: 'center',
            width: 100,
            value: 'signNumber',
            sortable: true
          },
          {
            text: '总合同额',
            align: 'center',
            width: 60,
            value: 'signPrice',
            sortable: true
          },
          {
            text: '合同额(通过)',
            align: 'center',
            width: 80,
            value: 'passSignPrice',
            sortable: false
          },
          {
            text: '实际收款',
            align: 'center',
            width: 60,
            value: 'returnMoney',
            sortable: false
          },
          {
            text: '应收款',
            align: 'center',
            width: 60,
            value: 'collectMoney',
            sortable: false
          },
          {
            text: '通过',
            align: 'center',
            width: 60,
            value: 'passNumber',
            sortable: false
          },
          {
            text: '未通过',
            align: 'center',
            width: 60,
            value: 'failNumber',
            sortable: false
          },
          {
            text: '进行中',
            align: 'center',
            width: 60,
            value: 'doingNumber',
            sortable: false
          },
           {
            text: '已完成',
            align: 'center',
            width: 60,
            value: 'doneNumber',
            sortable: false
          },
          {
            text: '中止',
            align: 'center',
            width: 60,
            value: 'stopNumber',
            sortable: false
          },
          {
            text: '通过率',
            align: 'center',
            width: 80,
            value: 'passRate',
            sortable: true,
            formatter: (val) => `${val}%`
          }
        ]
      }
    },
    methods: {
      statis () {
        this.loading = true
        year(this.params).then(res => {
          if (res.status === 200) {
            this.result = res.data
            this.changeState()
          }
          this.loading = false
        })
      },
      changeState (val) {
        const this_ = this
        this_.stateLabels = []
        this_.stateValue = []
        this.result.contractStates.forEach(s => {
          if (s.year !== -1) {
            this_.stateLabels.push(s.year)
            this_.stateValue.push(s[val] || s.signNumber)
          }
        })
      },
    },
    created () {
      this.statis()
    }
  }
</script>
